module.exports = __webpack_public_path__ + "static/media/icon-user.a99c5048.svg";